
function TermsCondition() {
  return (
    <>
        <div className="bg-banner1 flex items-center justify-center min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px] bg-cover bg-center">
            <h1 className="z-10 text-white bg-[#7b026b]/30 w-max px-10 py-2 md:py-5 text-[16px] md:text-[20px] uppercase font-heading">Terms and Condition</h1>
            <div className='bg-black/60 absolute w-full min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px]'>
            </div>
        </div>
        <div class="w-[80%] mx-auto py-[40px]">
               <h2 data-aos="fade-left" className="mb-4 font-heading text-[#7b026b] text-[16px]">Last Updated On : 9th Nov 2026</h2>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-3">
                    Welcome to <strong className="font-heading">IGPH Kamalanagar Church</strong>. By accessing or using our website, you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully before using this site.
                </p>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">1. General Information</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-3">
                    IGPH Kamalanagar Church is a Christian community website designed to share information about our church activities, worship services, and outreach programs. The content is provided for spiritual and informational purposes only.
                </p>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">2. Use of Website</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-2">By using this website, you agree to:</p>
                <ul  data-aos="fade-up" class="list-disc pl-6 font-body text-[15px] mb-3">
                    <li className="mb-1">Use the website only for lawful and faith-based purposes.</li>
                    <li className="mb-1">Respect other visitors and members of the church community.</li>
                    <li className="mb-1">Not misuse, copy, or distribute content without permission.</li>
                    <li className="mb-1">Refrain from posting offensive or inappropriate material.</li>
                </ul>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">3. Content Ownership</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-3">
                    All content, including text, images, videos, and logos on this website, are owned or licensed by IGPH Kamalanagar Church unless otherwise stated. Unauthorized use of our materials is strictly prohibited.
                </p>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">4. External Links</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-3">
                    Our website may contain links to other Christian organizations or external sites. IGPH Kamalanagar Church is not responsible for the content, privacy policies, or practices of any third-party websites.
                </p>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">5. Privacy and Data</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-2">
                    We value your privacy. Any personal information shared through forms or contact pages will be used solely for church-related communication and will not be shared without consent.
                </p>
                <ul  data-aos="fade-up" class="list-disc pl-6 font-body text-[15px] mb-3">
                    <li className="mb-1">Your data is kept confidential within our ministry team.</li>
                    <li className="mb-1">We do not sell or trade your personal information.</li>
                    <li className="mb-1">Cookies may be used to improve website performance.</li>
                </ul>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">6. Disclaimer</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-3">
                    While we strive to provide accurate and uplifting information, IGPH Kamalanagar Church makes no warranties about the completeness, reliability, or accuracy of any content. Your use of the site is at your own discretion.
                </p>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">7. Changes to Terms</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-3">
                    IGPH Kamalanagar Church reserves the right to modify or update these Terms and Conditions at any time. Changes will take effect immediately upon being posted on this page.
                </p>

                <h1  data-aos="fade-up" class="font-heading text-[15px] mt-4 mb-2">8. Contact Us</h1>
                <p  data-aos="fade-up" class="font-body text-[15px] mb-3">
                    If you have any questions about these Terms and Conditions, please contact us through our <strong>Contact</strong> page or visit us at IGPH Kamalanagar Church.
                </p>

                <p  data-aos="fade-up" class="font-body text-[15px] italic mt-4">
                    Thank you for being part of our faith community. May your experience here be inspiring and blessed.
                </p>
        </div>
    </>
  )
}

export default TermsCondition